import { get } from 'lodash/fp';
import colours from '../../../colours';
import { getCurrentUser } from '../../services/CurrentUser';
import { isFeatureEnabled } from '../../services/Features';

export default function renderTintColor() {
    if (isFeatureEnabled('FEATURE_layoutRefresh')) {
        return colours.SIYellow;
    } else {
        return get('company.companyDesignSettings.companyColor', getCurrentUser()) || colours.SIYellow;
    }
}
